
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCrudHooks, processResult } from "../common/queries";
import api from "../http-common";

export const courseDetailApi = {
	...createCrudHooks({
		baseKey: "courseDetails",
		basePath: "/courseDetails",
		getParams: { include: ['course', 'attachments', 'parentDetail'] },
	}),

	//@Override
	useDelete() {
		const qc = useQueryClient();
		return useMutation({
			mutationFn: ({ courseId, id }) => api.delete(`/courseDetails/${id}`),
			onSuccess: (_, { courseId, id }) => {
				console.log(courseId, id);
				const previous = qc.getQueryData(['courses', courseId]);
				qc.setQueryData(['courses', courseId], old => {
					if (!old) return old;
					return {
						...old,
						courseDetails: old.courseDetails.filter(cd => cd.id !== id && id.indexOf?.(cd.id) < 0),
					};
				});

				return { previous };
			},
		});
	},

	useAddBefore() {
		const qc = useQueryClient();
		return useMutation({
			mutationFn: (id) => api.post(`/courseDetails/${id}/_addBefore`).then(r => processResult(qc, r)),
		});
	},

	useAddAfter() {
		const qc = useQueryClient();
		return useMutation({
			mutationFn: (id) => api.post(`/courseDetails/${id}/_addAfter`).then(r => processResult(qc, r)),
		});
	},
}
